import httpService from "./httpService";

const NotifiactionApi = {

    getNotifiactionList: (limit,page) => httpService.get(`notifiaction`, {
        params: {
            limit,
            page: page,
        }
    }),
    markAllReadNotifiaction: () => httpService.put(`notification/mark-all-as-read`),

    updateNotifiaction: (id) => httpService.post(`read-notifiaction`, { id: id }),
    countNotifiaction: () => httpService.get(`notifiaction-count`),

}

export default NotifiactionApi;